function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Slice");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_recurring",
  transform: "translate(-11.000000, -11.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_59",
  stroke: "#000000",
  cx: 31.7,
  cy: 51.5,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_60",
  stroke: "#000000",
  cx: 55.9,
  cy: 51.5,
  r: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M41,70.5 L41,69.5 C56.7401153,69.5 69.5,56.7401153 69.5,41 C69.5,35.7841648 68.0972768,30.7751007 65.4792889,26.3963207 C63.458862,23.017006 60.7547136,20.0848797 57.5508976,17.7955494 C52.7572759,14.3702017 47.0199042,12.5 41,12.5 C25.2598847,12.5 12.5,25.2598847 12.5,41 C12.5,46.7704451 14.2179034,52.2833103 17.3835926,56.9587222 C19.9324754,60.723172 23.3513562,63.836741 27.3392819,66.018916 L26.8592531,66.8961688 C22.731631,64.6375525 19.1935033,61.4153855 16.5555484,57.5193852 C13.2786614,52.6797448 11.5,46.9719033 11.5,41 C11.5,24.7075999 24.7075999,11.5 41,11.5 C47.2301258,11.5 53.1704039,13.4363428 58.1322856,16.9819228 C61.4480005,19.3512121 64.2464552,22.3855954 66.3375833,25.8831631 C69.0476739,30.4159918 70.5,35.6021856 70.5,41 C70.5,57.2924001 57.2924001,70.5 41,70.5 Z",
  id: "Ellipse_60",
  fill: "#000000",
  fillRule: "nonzero",
  transform: "translate(41.000000, 41.000000) rotate(-140.000000) translate(-41.000000, -41.000000) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_1656",
  stroke: "#000000",
  x: 26,
  y: 27.5,
  width: 25,
  height: 19
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Pfad_1176",
  stroke: "#000000",
  points: "59.3 51.5 62 51.5 62 41.9 55.7 33.8 53.9 33.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53,51.5 L34.1,51.5",
  id: "Linie_104",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.7,51.5 L25,51.5",
  id: "Linie_105",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23,43.5 L18,43.5",
  id: "Linie_106",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23,46.5 L20,46.5",
  id: "Linie_107",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.302175,17.4268445 L63.802175,21.4268445 C61.451034,18.8379901 60.2754635,17.5435629 60.2754635,17.5435629 C60.2754635,17.5435629 59.1177006,18.8379901 56.802175,21.4268445 L60.302175,17.4268445 Z",
  id: "Triangle",
  stroke: "#000000",
  fill: "#D8D8D8",
  transform: "translate(60.302175, 19.426844) rotate(138.000000) translate(-60.302175, -19.426844) "
})));

var SvgIconRecurring = function SvgIconRecurring(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRecurring, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_recurring.e22d6adb.svg";
export { ForwardRef as ReactComponent };